import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '2f7f18c71ab03a692cb9911ed85b2960.png',
	fr: '6fbdfc9eedf293ca57dba5b22b18bb00.png',
};

export const Hero: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h1">
						{t(
							'musicquizlandingpage_title_Xfeaturenamehaslanded_standalone-web',
							{ns: 'musicquiz'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'musicquizlandingpage_text_Xfeaturenamehaslanded_standalone-web',
							{ns: 'musicquiz'},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{
							eventaction: 'discover-channel-game',
							eventlabel: 'main-CTA',
						}}
						href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fchannels%2Fgames%3Fbypassreferer%3D1&amv=8.0.12&imv=10.12.0"
						isMain
					>
						{t('generic_action_playnow_standalone-web', {ns: 'common'})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					h={{base: '250px', md: '100%'}}
					alt={t('generic_action_playnow_standalone-web')}
					quality={90}
					src={src}
					aspectRatio="1440/420"
					objectFit={{base: 'cover', sm: 'contain'}}
					priority
				/>
			}
		/>
	);
};
